const store = {//平板尺寸  1280*720
	    baseUrl : 'http://58.221.55.183:8886/api/gaoChaForWmsApi',
		// baseUrl : 'http://192.168.0.9:8082/api/gaoChaForWmsApi',
		// baseUrl : 'http://192.168.43.30:8082/api/gaoChaForWmsApi',
		version: 'V-1.6',
		
}
export default store
